export default {  
    SET_PERSONNEL: (state, payload) => state.personnel = payload,
    SET_PERSONNEL_STATUSES: (state, payload) => { 
      state.statuses = payload;
      (payload || []).forEach(s => state.statusesMap[s.id] = s.description);
    }
  }